import type { Locale } from '@lemonade-hq/lemonation';
import { type Config as ConfigDeDe, config as deDeConfig } from './de/de';
import { config as deEnConfig } from './de/en';
import { type Config as ConfigEnFr, config as frEnConfig } from './fr/en';
import { type Config as ConfigFrFr, config as frFrConfig } from './fr/fr';
import { type Config as ConfigEnGb, config as enGbConfig } from './gb/en';
import { type Config as ConfigEnNl, config as nlEnConfig } from './nl/en';
import { type Config as ConfigNlNl, config as nlNlConfig } from './nl/nl';
import { type Config as ConfigEnUS, config as enUsConfig } from './us/en';

export type Config =
  | ConfigEnUS
  | ConfigNlNl
  | ConfigEnNl
  | ConfigFrFr
  | ConfigDeDe
  | ConfigEnFr
  | ConfigEnUS
  | ConfigEnGb;

export const homeTemplateConfig = {
  'en-US': enUsConfig,
  'de-DE': deDeConfig,
  'nl-NL': nlNlConfig,
  'fr-FR': frFrConfig,
  'en-GB': enGbConfig,
  'en-NL': nlEnConfig,
  'en-FR': frEnConfig,
  'en-DE': deEnConfig,
} as Record<Locale, Config>;
